window.globals = {
  init: function () {
    const contactAvailabilityElements = document.querySelectorAll(
      '[data-contact-section-selector="contact-availability"]',
    );

    contactAvailabilityElements.forEach((item) => {
      this.checkCallcentreAvailability(item);
    })
  },

  checkCallcentreAvailability: function (avatar) {
    const now = new Date();
    const day = now.getDay();
    const currentHour = now.getHours();

    const workdaysStart = parseInt(avatar.dataset.workdaysStart, 10);
    const workdaysEnd = parseInt(avatar.dataset.workdaysEnd, 10);
    const saturdayStart = parseInt(avatar.dataset.saturdayStart, 10);
    const saturdayEnd = parseInt(avatar.dataset.saturdayEnd, 10);
    const sundayStart = parseInt(avatar.dataset.sundayStart, 10);
    const sundayEnd = parseInt(avatar.dataset.sundayEnd, 10);

    let isOnline = false;

    if (day >= 1 && day <= 5) {
      isOnline = currentHour >= workdaysStart && currentHour < workdaysEnd;
    } else if (day === 6) {
      isOnline = currentHour >= saturdayStart && currentHour < saturdayEnd;
    } else if (day === 0) {
      isOnline = currentHour >= sundayStart && currentHour < sundayEnd;
    }

    if (!isOnline) {
      avatar.classList.add("offline");
    }
  },
};

document.addEventListener("DOMContentLoaded", window.globals.init());
